const requestPermission = async () => {
  if("Notification" in window) {
    await Notification.requestPermission();
  }
}

export { requestPermission };
